import { render, staticRenderFns } from "./allProducts.vue?vue&type=template&id=44a23416&scoped=true"
import script from "./allProducts.vue?vue&type=script&lang=js"
export * from "./allProducts.vue?vue&type=script&lang=js"
import style0 from "./allProducts.vue?vue&type=style&index=0&id=44a23416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a23416",
  null
  
)

export default component.exports